import React from "react";
import { Tabs } from "antd";
import AccountingSummary from "./summary";
import SystemIncomes from "./systemIncoms";
import SideIncomes from "./sideIncomes";
import SideExpenditures from "./sideExpenditures";
function AdminAccounting(props) {
  const items = [
    {
      label: "خلاصه حسابداری",
      key: "accountingSummary",
      children: <AccountingSummary />,
    },
    {
      label: "درآمدهای سیستمی",
      key: "systemIncomes",
      children: <SystemIncomes />,
    },
    {
      label: "درآمدهای جانبی",
      key: "sideIncomes",
      children: <SideIncomes />,
    },
    {
      label: "هزینه های جانبی",
      key: "sideExpenditures",
      children: <SideExpenditures />,
    },
  ];
  return (
    <div>
      <Tabs items={items} />
    </div>
  );
}

export default AdminAccounting;
